/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import { useFlags } from 'sarsaparilla';
import { Freedom250Logo } from './Freedom250Logo';

import Freedom250LogoStyles from './Freedom250LogoStyles.module.scss';

// Still using the America250 LD flag because
export function Freedom250LogoWrapper() {
    const { freedom250GlobalNavLogo } = useFlags();

    if (!freedom250GlobalNavLogo?.enabled) {
        return null;
    }

    const { link } = freedom250GlobalNavLogo;

    return (
        <div className={Freedom250LogoStyles.freedom250LogoHolder}>
            <a
                href={link}
                aria-label="America250"
                id="ga-global-nav-freedom250Logo-link"
                data-ga-tracking-id="111575432216"
                data-ga-tracking-value="Freedom250 Global Nav"
            >
                <Freedom250Logo />
            </a>
        </div>
    );
}
